import styles from "./CardSectionLinkMenu.module.scss";

import React from "react";
import Media from "../../../../CmsComponents/Media/Media";
import RichText from "../../../../CmsComponents/RichText/RichText";
import { BNBox, BNButton } from "@bn-monorepo/js-packages";
import BNLink from "../../../../BnComponents/BNLink/BNLink";

interface MenuButton {
  img?: string;
  alt: string;
  name: string;
  info: string;
  href: string;
  isSpa: boolean;
}
interface Props {
  menuButtons: MenuButton[];
  title: string;
  enabled?: boolean;
}

const CardSectionLinkMenu: React.FC<Props> = (props) => {
  const { title, menuButtons, enabled } = props;
  if (!enabled) return null;
  return (
    <section className={styles.mainWrapper}>
      <div className={styles.containerWrapper}>
        {title && <h2 className={styles.header}>{title}</h2>}
        {menuButtons && (
          <nav aria-label={`image-menu: ${title}`}>
            <BNBox
              component={"ul"}
              sx={{
                listStyle: "none",
                display: "grid",
                gridTemplateColumns: {
                  xs: `repeat(${Math.round(menuButtons.length / 3)}, 1fr)`,
                  sm: `repeat(${Math.round(menuButtons.length) / 2}, 1fr)`,
                  md: `repeat(${Math.round(menuButtons.length)}, 1fr)`,
                },
                gap: "0.5em",
                p: 1,
                m: 0,
              }}
            >
              {menuButtons.map((button, index) => (
                <li key={`menuButtons-${index}`} className={styles.menuElement}>
                  <BNLink isSpa={button.isSpa} href={button.href}>
                    <div className={styles.linkContainer}>
                      {button.img && (
                        <Media
                          AltText={button.alt}
                          imagePath={button.img}
                          className={styles.image}
                          noWrapper={true}
                          maxWidth={260}
                          aspectRatio={"260:110"}
                        />
                      )}
                      <BNButton>{button.name}</BNButton>
                    </div>
                  </BNLink>
                  <div className={styles.text}>
                    <RichText html={button.info} />
                  </div>
                </li>
              ))}
            </BNBox>
          </nav>
        )}
      </div>
    </section>
  );
};
export default CardSectionLinkMenu;
